export interface IPresignedUploadParams<Context = unknown> {
  file: File;
  url: string;
  fields: Record<string, string>;
  method: 'POST' | 'PUT';
  context?: Context;
  headers?: Record<string, string>;
  signal?: AbortSignal;
}

export interface IPresignedUploadResponse {
  success: boolean;
}

export interface IPresignedUploadApi {
  upload<Context = unknown>(params: IPresignedUploadParams<Context>): Promise<IPresignedUploadResponse>;
}

export default class PresignedUploadRestApi implements IPresignedUploadApi {
  public async upload<Context = unknown>(params: IPresignedUploadParams<Context>): Promise<IPresignedUploadResponse> {
    const { file, url, fields, method, headers = {}, signal } = params;

    const body = method === 'PUT' ? file : this.createFormData(fields, file);

    const response = await fetch(url, { method, body, headers, signal });

    if (!response.ok) {
      throw new Error(`Upload failed for file ${file.name}`);
    }

    return { success: true };
  }

  private createFormData(fields: Record<string, string>, file: File) {
    const formData = new FormData();

    Object.entries(fields).forEach(([key, value]) => formData.append(key, value));

    formData.append('file', file);

    return formData;
  }
}
